import { ButtonColor } from '../../../ui/gzIconButton/types';

export enum ToolbarEvents {
  LIVE_VIEW_BUTTON_CLICKED = 'liveViewButtonClicked',
  EXPORT_BUTTON_CLICKED = 'exportButtonClicked',
  CREATE_REPORT_BUTTON_CLICKED = 'createReportButtonClicked',
  REFRESH_DASHBOARD_BUTTON_CLICKED = 'refreshDashboardButtonClicked',
  SETTINGS_PANEL_BUTTON_CLICKED = 'settingsPanelButtonClicked',
  EXPAND_VIEW_BUTTON_CLICKED = 'expandViewButtonClicked',
  EXPORT_PDF_OPTION_CLICKED = 'exportPdfOptionClicked',
  EXPORT_CSV_OPTION_CLICKED = 'exportCsvOptionClicked',
  FILTERS_BUTTON_CLICKED = 'filtersButtonClicked',
}

export interface GDToolbarButtonConfig {
  id: string;
  class: string;
  icon: string;
  buttonColor: ButtonColor;
  disabled: boolean;
  eventName: ToolbarEvents;
  buttonWithDropdown?: boolean;
  tooltipText: string;
}

export interface ToolbarButtonsTooltips {
  activateLiveView: string;
  disableLiveView: string;
  unavailableLiveView: string;
  export: string;
  createReport: string;
  refresh: string;
  unavailableRefresh: string;
  openSettings: string;
  closeSettings: string;
  activateExpandView: string;
  disableExpandView: string;
  showFilters: string;
  hideFilters: string;
}

export enum SelectOptionValues {
  EXPORT_PDF = 'exportPdf',
  EXPORT_CSV = 'exportCsv',
}
